export const MESSAGES = {
  EDITOR_VIEW_RAW: "raw",
  EDITOR_VIEW_FORM: "form",
  REQ_HINT: "Must not exceed 12 MB and must be in jpg, png, tif, gif, pdf format",
  PASTE_JSON: "Please paste the JSON text here or",
  INVALID_JSON: "Invalid JSON",
  INVALID_DEPENDENCY: "Invalid Dependency",
  DELETE_CONFIRMATION: "Are you sure to delete this field?",
  RESET_CONFIRMATION: "This will delete all contents of the current form. \nPlease cancel and export your work if not yet done.\nOtherwise, press OK to proceed.",
  CANCEL_CONFIRMATION: "Are you sure to cancel adding new component?",
  DISCARD_CONFIRMATION: "You have unsaved changes,\nAre you sure to discard it?",
  LOAD_SAMPLE_CONFIRMATION: "The current JSON form will be discarded,\nDo you want to proceed loading the sample JSON?",
  LOAD_JSON_CONFIRMATION: "The current JSON form will be discarded,\nDo you want to proceed loading the file?",
  EXPORT_CONFIRMATION: "Downloading JSON file",
  COPY_NOTIFICATION: "Copied to Clipboard",
  EXPORT_SUCCESS: "Exported successfully",
  EXPORT_FAILED: "Failed to export",
  UPDATE_COMPONENT_TITLE: "Update Component",
  ADD_COMPONENT_TITLE: "Add Component",
  DEPENDENCY_HINT: "Multiple values should be comma-delimited",
  JSON_FILE_TYPE: "Please upload a JSON file",
  FAILED_DUE_TO_INVALID: "Export failed due to invalid JSON.",
  EXPORT_NO_CONTENT: "Cannot export a blank file.",
  COPY_NO_CONTENT: "No content is copied to clipboard.",
}

export const VALIDATION_ERROR_MESSAGES = {
  FILL_REQUIRED_FIELD: "Please fill in all the required fields",
  FILL_EDITOR: "Please fill in the text editor",
  ADD_OPTION: "Please add at least one option to the options field",
  FILL_OPTIONS: "Please fill in the label and value for all the options",
  NO_SPECIAL_CHAR: "Field Name should start with a letter and can only contain letters and numbers.",
}

export const ROOT_NODE = {
  FIELDS: "fields",
  AREAS: "areas",
}

// official name : readable name
export const FIELD_COMP_TYPE = {
  STATIC : "Text",
  INPUT_TEXT: "Text Box",
  OPTION_GROUP: "Radio / Checkboxes",
  CHECKBOX: "Single Checkbox",
  SELECT: "Dropdown",
  FILE: "File",
  PDICS: "Individual or Corporate",
  PhyAttend: "Physical Attendance Request",
  AgreeTerms: "Agree to Company Terms",
}

export const FIELD_SPECIAL_COMP = [
  "PDICS",
]

export const AREA_COMP_TYPE = {
  TEXT: "Short Text",
  PFSI: "Proxy Form Shareholder Information",
  PFCP: "Proxy Form Chairman Proxy",
  PFRP: "Proxy Form Real Proxyholder",
  PFTS: "Proxy Form Total Shares",
  PFHT: "Proxy Form Shares by Shareholding Type",
  PFDS: "Proxy Form Date Submitted",
  PFRT: "Proxy Form Resolutions",
  VFRT: "Voting Form Resolutions",
  PRCT: "Poll Results for Chairman",
}

export const COMPONENT_TYPE = {
  STATIC : "STATIC",
  INPUT_TEXT: "INPUT_TEXT",
  OPTION_GROUP: "OPTION_GROUP",
  CHECKBOX: "CHECKBOX",
  SELECT: "SELECT",
  FILE: "FILE",
  PDICS: "PDICS",
  TEXT: "TEXT",
  PFSI: "PFSI",
  PFCP: "PFCP",
  PFRP: "PFRP",
  PFTS: "PFTS",
  PFHT: "PFHT",
  PFDS: "PFDS",
  PFRT: "PFRT",
  VFRT: "VFRT",
  PRCT: "PRCT",
}

// to skip a few validation such as fieldName because it is fixed in special component
export const SPECIAL_COMPONENT = [
  "PDICS", "PhyAttend", "AgreeTerms", 
  "PFSI", "PFCP", "PFRP", "PFTS", "PFHT", "PFDS", "PFRT",
  "VFRT", "PRCT"
]

// to determine and prevent added the type directly to the FormEditor
export const NO_COMP_TYPE = [
  "PhyAttend", "AgreeTerms"
]

export const SHARED_VALUES_KEY_MAPPING = [
  "companyNm",
  "conveneTC",
  "convenePrivacy"
]

export const PLACEHOLDERS = {
  COMPANY_NAME: "Company Name",
  REG_END_DATE: "Registration End Date",
  REG_END_TIME: "Registration End Time",
  LIST_CO: "Listed Company",
  ORG_URL: "Meeting Link",
  conveneTC: "Convene's Term and Conditions",
  convenePrivacy: "Convene's Privacy Policy"
}

export const DEFAULT_NEW_FIELD = {
  layout: {
    seq: 0,
  },
  metadata: {
    type: "INPUT_TEXT",
    inputType: "text"
  }
}

export const DEFAULT_NEW_AREA = {
  layout: {
    seq: 0,
  },
  metadata: {
    type: "STATIC",
    content: ""
  }
}

export const ALERT_TYPE = {
  ERROR: "error",
  SUCCESS: "success",
  INFO: "info",
  POP_UP_EDITOR_ERROR: "popUpError",
}

export const FILE_EXTENSIONS = {
  JPG: ".jpg",
  PNG: ".png",
  PDF: ".pdf"
}

export const TEXT_SIZE = {
  h1: "Header 1", 
  h2: "Header 2", 
  h3: "Header 3", 
  h4: "Header 4", 
  h5: "Header 5", 
  h6: "Header 6", 
  p: "Paragraph", 
  span: "Span"
}

export const TOOLTIP_TEXT = {
  //// HOME ////
  ADD_NEW_COMPONENT: "Insert a new component at the end of the form",
  RESET_FORM: "Delete all contents of the current form.",
  EXPORT_FILE: "Export form to JSON file",
  COPY_TO_CLIPBOARD: "Copy form JSON to clipboard",
  LOAD_SAMPLE_JSON: "Load selected sample form and discard current form, if any",
  SWITCH_VIEW: "Toggle the switch to view the form in different modes",
  LOAD_FROM_FILE: "Upload your JSON text from file",
  //// LAYOUT MODAL ////
  SEQUENCE: "The position of the component in the form",
  VERTICAL_ALIGN: "The vertical alignment of the component",
  MARGIN_BOTTOM: "Set additional space at the bottom of the component",
  COLUMN_SIZE: "Set the allotted width for the component; accepts values 1-12",
  CLASS_NAME: "Set component style based on existing class in web application",
  INLINE: "Set this component in the same line as other components in the form",
  BORDER: "Set a black border around the component",
  PADDED: "Set additional padding around the component",
  //// BASE COMPONENT ////
  TYPE_FIELD: "Change the type of the component",
  RAW_HTML: "The raw HTML of the text component",
  PLACEHOLDERS: "These will be replaced with actual values set for the meeting in the actual form",
  INPUT_LABEL: "Set the component label",
  CHECKBOX_LABEL: "The label beside the checkbox to describe the component",
  HINT: "Notes in grey text describing the component",
  REQUIRED: "Set the component as mandatory",
  READ_ONLY_IF_HAS_VALUE: "Set component in readonly mode if it has value",
  INPUT_TYPE: "Adds validation for non-text type such as numeric, email",
  DEFAULT_VALUE: "Set the default value of this component",
  PREFIX: "Append this text at the beginning of the component input",
  FIELD_NAME: "Name of this component as processed by the web application.",
  MIN_LENGTH: "Set the minimum length allowed for input",
  MAX_LENGTH: "Set the maximum length allowed for input",
  DEPENDENCY: "This component will only be displayed once the parent field value is set as specified",
  OPTION_TYPE: "Checkbox allows multiple selection, radio allows single selection",
  OPTIONS: "Set for each option the label shown to user and the value to be saved in the database",
  SHOW_REQ_HINT: "If checked, there will be a hint about the acceptable file type, size...",
  SHOW_FIELD_LABEL: "If it is not checked, the label will be hidden",
  FILE_TYPE: "To specify the file type that user can upload",
  LABEL_WIDTH: "The length of the label, scale from 1 - 12",
  //// FIELDS SPECIAL COMPONENT ////
  COMPONENT_LABEL: "Set the label of this component",
  INDIVIDUAL_SHAREHOLDER_LABEL: "Set the label of the first choice",
  CORPORATE_SHAREHOLDER_LABEL: "Set the label of the second choice",
  IND_SHAREHOLDER_NAME: "Set the label for the field under first choice",
  CORP_SHAREHOLDER_COMP: "Set the label for the field under second choice",
  CORP_SHAREHOLDER_REP: "Set the label for the field under second choice",
  PHY_ATTEND_LABEL: "The title of the text component",
  PHY_ATTEND_PARAGRAPH: "The paragraph of the text component",
  PHY_ATTEND_CHECKBOX: "The label of the checkbox below the paragraph",
  //// AREAS SPECIAL COMPONENT ////
  TEXT_SIZE: "The text size",
  TEXT_CONTENT: "The text to display",
  PFSI_READ_ONLY: "If checked, the self-claiming will not be editable",
  HIDE_INLINE_LABEL: "Hide or show the inline label of the input box",
  HIDE_PROPORTION_HEADER: "Hide or show the text \"Proportion of Shareholdings\"",
  DEFAULT_CHAIRMAN: "Set the default choice of proxyholder for the form",
}